module.exports = __webpack_public_path__ + "img/objective-2@2x.3bed7969.jpg";